import axios from 'axios';
import { config_headers, config_headers_export, servicelist, URL_API } from '../Config';

export const P206GetDataInfo = async (body) => {

    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_inspect_main_info`), body, authorization)
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P206UpdateData = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_inspect_main_update`), body, authorization)
                .then(res => {
                    resolve(res);
                })
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P206UpdateClose = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_inspect_close_job`), body, authorization)
                .then(res => {
                    resolve(res);
                })
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P206GetPicDataList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_inspector_list`), body, authorization)
                .then(res => {
                    resolve(res.data);
                })
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P206UpdateInspectorData = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);   
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_inspector_update`), body, authorization)
                .then(res => {
                    resolve(res);
                })
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}


export const PSupervisorInspectCaseReport = async (body, exportType = "") => {
    return new Promise(async (resolve, reject) => {
        try {

            let authorization = await config_headers_export(exportType);
            await axios
                .post(URL_API(`${servicelist.SupervisorService}p_supervisor_inspect_case_report`), body, authorization)
                .then((res) => {
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        }
    });
};
